/**
 * Helper
 */
var helper = require('../../helper'),
    dataTables_buttons = [

        {
            extend: 'csv',
            text: 'Export as CSV',
            exportOptions: {
                columns: '.data-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'pdf',
            text: 'Export as PDF',
            exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6, 7]
            },
            className: 'btn btn-default'
        },
        {
            extend: 'colvis',
            className: 'btn btn-default'
            //     columns: ':gt(0)'
        }

    ],
    dataTables_columns_export = [
        {data: 'bankDetails', name: 'bankDetails', title: 'Bank Details', orderable: false, searchable: false, visible: false, className: 'data-export'},
        {data: 'fullAddress', name:'fullAddress', title: 'Address', orderable: false, searchable: false, visible: false, className: 'data-export'},
        {data: 'address_1', name:'clients.address_1', title: 'Address 1', orderable: false, searchable: true, visible: false, className: 'data-export'},
        {data: 'address_2', name:'clients.address_2', title: 'Address 2', orderable: false, searchable: true, visible: false, className: 'data-export'},
        {data: 'address_3', name:'clients.address_3', title: 'Address 3', orderable: false, searchable: true, visible: false, className: 'data-export'},
        {data: 'town', name:'town', title: 'Town', orderable: false, searchable: true, visible: false, className: 'data-export'},
        {data: 'postcode', name:'postcode', title: 'Postcode', orderable: false, searchable: true, visible: false, className: 'data-export'},
        {data: 'phone_number', name:'phone_number', title: 'Phone number', orderable: false, searchable: true, visible: false, className: 'data-export'},
        {data: 'vip_amount', name:'vip_amount', title: 'VIP amount', orderable: false, searchable: true, visible: false, className: 'data-export'},
        {data: 'savings_made', name:'savings_made', title: 'Savings made', visible: false, className: 'data-export'},
        {data: 'internal_info', name:'internal_info', title: 'Internal info', visible: false, className: 'data-export'},
        {data: 'region', name:'region', title: 'Region', visible: false, className: 'data-export'},
        {data: 'updated_at', name:'updated_at', title: 'Last Updated', visible: false, className: 'data-export'}
    ];

$(function() {
    var $datatable = $('#datatable-all-clients'),
        $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/clients",
            "method": 'POST',
            "data": function ( d ) {
                d.status_id = (localStorage.getItem('DataTables_all_clients_status_id')) ? localStorage.getItem('DataTables_all_clients_status_id') : $('input[name="clickedStatusId"]').val();
            }
        },
        "stateSave": true,
        "stateSaveCallback": function(settings,data) {
            localStorage.setItem( 'DataTables_all_clients_state_' + settings.sInstance, JSON.stringify(data) );
            localStorage.setItem('DataTables_all_clients_status_id', $('input[name="clickedStatusId"]').val() );
        },
        "stateLoadCallback": function(settings) {
            return JSON.parse( localStorage.getItem( 'DataTables_all_clients_state_' + settings.sInstance ) )
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        'columnDefs': [{
            'targets': 19,
            'className': 'dt-body-center tiny-column',
            'render': function (data, type, full, meta){
                return '<textarea id="internal_info-'+data[0]+'" rows="5" cols="75" type="text" name="internal_info[]" class="js-client-update-field-text" data-id="'+data[0]+'" data-field="internal_info">'+data[1]+'</textarea>';
            },
        },],
        "columns": [
            {data: 'name', name: 'name', className: 'data-export'},
            {data: 'status', name: 'status', className: 'data-export'},
            {data: 'web', name: 'web', className: 'data-export'},
            {data: 'managerFirstName', name: 'managerFirstName', className: 'data-export'},
            {data: 'managerLastName', name: 'managerLastName', className: 'data-export'},
            {data: 'leadSource', name: 'leadSource', className: 'data-export'},
            {data: 'marketSegment', name: 'marketSegment', className: 'data-export'},
            {data: 'bankAccount', name: 'bankAccount', className: 'data-export'},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ]
            .concat(dataTables_columns_export)
    });

    $('.js-activity-box').on('click', function() {
        var $clickedStatusId = $('input[name="clickedStatusId"]'),
            statusId = $(this).data('status_id');

        $clickedStatusId.val(statusId);

        localStorage.setItem( 'DataTables_all_clients_state_' + $dt.settings.sInstance, JSON.stringify( $dt.data ) );
        localStorage.setItem( 'DataTables_all_clients_status_id', $('input[name="clickedStatusId"]').val() );

        $dt.ajax.reload();
    });

    $('.js-clients-email-of-status').on('change', function(e) {
        var statusId = $(this).val();

        if(statusId > 0){
            window.location.href = helper.getOrigin() + "/clients/emails/" + statusId;
        }
    });

});
